<template>
  <div class="Technology-box">
    <div class="Technology" ref="TechnologyPage">
      <div class="Technology_content">
        <!--<img src="../assets/images/BitmapCopy.png" alt="">-->
        <p class="content_text" ref="TechnologyPage1">{{$t("Technologies.TechnologiesTop")}}</p>
      </div>
    </div>
    <div class="Technology_wrap" ref="TechnologyPage2">
      <div class="Technology_ADAS">
        <!--<div class="Technology_ADAS_title">
              <p>ADAS</p>
              <span></span>
            </div>-->
        <headerbar v-bind:message="aboutMeg"></headerbar>
        <div class="Technology_ADAS_text">
          <p>{{$t("Technologies.TechnologiesAdas")}}</p>
        </div>
        <div class="Technology_ADAS_content">
          <div class="Technology_ADAS_list" v-for="(item,index) in ADAS" :key="index">
            <div class="Technology_ADAS_list_img" :class="pulse" @mouseenter="enterOrLeave(1,index)"
              @mouseleave="enterOrLeave(2,index)"><img v-lazy="item.img" alt=""></div>
            <p class="Technology_ADAS_list_p">{{item.title}}</p>
            <div class="Technology_ADAS_list_pp">{{$t(item.text)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="Technology_wrapa" ref="TechnologyPage3">
      <div class="Technology_ADASVideo">
        <!--<div class="Technology_ADASVideo_title">
              ADAS演示视频
              <p></p>
            </div>-->
        <headerbar v-bind:message="$t(aboutMegs)"></headerbar>
        <div class="Technology_ADASVideo_content">
          <div class="ADASvideo">
            <!--<div style="width:100%;height:100%"></div>-->
            <video src="../../static/adaslow.mp4" poster="../assets/images/videoCover.png" width="100%" height="100%"
              id="video" controls controlslist="nodownload"></video>
          </div>
          <!--<div v-if="ADASvideo" class="Technology_ADASVideo_content_img" @click="ADASVideoBtn()">
                      <img src="../assets/images/播放.png" alt="">
                    </div>-->
        </div>
      </div>
    </div>
    <div class="Technology_wrapb" ref="TechnologyPage4">
      <div class="Technology_DMS">
        <div class="Technology_DMS_title">
          <p>DMS</p>
          <span></span>
        </div>
        <div class="Technology_DMS_text">
          <p>{{$t("Technologies.DMS.DMStext")}}</p>
        </div>
        <div class="Technology_DMS_content">
          <div class="Technology_DMS_list" v-for="(item,index) in dms" :key="index">
            <div class="Technology_DMS_list_img" :class="pulse" @mouseenter="enterOrLeave(1,index)"
              @mouseleave="enterOrLeave(2,index)">
              <img v-lazy="item.img" alt="">
            </div>
            <p>{{$t(item.text)}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="Technology_wrap" ref="TechnologyPage6" style="background: rgba(251, 251, 251, 1);">
      <div class="Technology_Face">
        <!--<div class="Technology_Face_title">
            <p>人脸识别 · Face Recognition</p>
            <span></span>
          </div>-->
        <headerbar v-bind:message="$t(Recognition)"></headerbar>
        <div class="Technology_Face_content">
          <div class="Technology_Face_list" v-for="(item,index) in face" :key="index">
            <div class="Technology_Face_list_img">
              <img v-lazy="item.img" alt="">
            </div>
            <p>{{$t(item.text)}}</p>
          </div>
        </div>
        <!-- <a class="Technology_Face_text" :class="pulse" @mouseenter="enterOrLeave(1)" @mouseleave="enterOrLeave(2)"
          href="#" @click="Facebutton()">{{$t("Technologies.Face.ClickHere")}}</a> -->
      </div>
    </div>
    <div class="Technology_wrapd" ref="TechnologyPage7">
      <div class="Technology_number">
        <ul class="Technology_number_top">
          <li>
            <div class="list_top">
              <p>{{$t("Technologies.Face.HeadCounting")}}</p>
              <span></span>
            </div>
            <div class="list_bottom">
              <p>{{$t("Technologies.Face.HeadCountingtext")}}</p>
            </div>
          </li>
          <li class="list_img">
            <img v-lazy="list_img" alt="">
          </li>
        </ul>
        <ul class="Technology_number_bottom">
          <li class="list_bottom_img">
            <img v-lazy="list_bottom_img" alt="">
          </li>
          <li class="listt_bottom_right">
            <div class="listt_bottom_top">
              <p>{{$t("Technologies.Face.IntrusionWarning")}}</p>
              <span></span>
            </div>
            <div class="list_t_bottom_bottom">
              <p>{{$t("Technologies.Face.IntrusionWarningtext")}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import headerbar from "../components/common/header.vue";
export default {
  name: "Technology",
  data() {
    return {
      ADASvideo: true,
      clientHeight: "",
      aboutMeg: "ADAS",
      aboutMegs: "Technologies.Technologiesvideo",
      Recognition: "Technologies.Face.FaceRecognition",
      //ADAS第二屏
      ADAS: [
        {
          img: require("../assets/images/Group16Copy.png"),
          title: "LDW",
          text: "Technologies.ADAStext.LDW"
        },
        {
          img: require("../assets/images/Group16Copy1.png"),
          title: "FCW",
          text: "Technologies.ADAStext.FCW"
        },
        {
          img: require("../assets/images/Group16Copy2.png"),
          title: "PCW",
          text: "Technologies.ADAStext.PCW"
        },
        {
          img: require("../assets/images/Group16Copy3.png"),
          title: "HW",
          text: "Technologies.ADAStext.HW"
        },
        {
          img: require("../assets/images/Group16Copy5.png"),
          title: "SG",
          text: "Technologies.ADAStext.SG"
        },
        {
          img: require("../assets/images/Group16Copy4.png"),
          title: "TSR",
          text: "Technologies.ADAStext.TSR"
        }
      ],
      //疲劳预警第四屏
      dms: [
        {
          img: require("../assets/images/1.png"),
          text: "Technologies.DMS.Distraction"
        },
        {
          img: require("../assets/images/2.png"),
          text: "Technologies.DMS.Calling"
        },
        {
          img: require("../assets/images/3.png"),
          text: "Technologies.DMS.Tired"
        },
        {
          img: require("../assets/images/4.png"),
          text: "Technologies.DMS.Smoking"
        }
      ],
      //人脸识别，第六屏
      face: [
        {
          img: require("../assets/images/Group7Copy2.png"),
          text: "Technologies.Face.Takingpictures"
        },
        {
          img: require("../assets/images/Group7.png"),
          text: "Technologies.Face.Uploadingpictures"
        },
        {
          img: require("../assets/images/Group71.png"),
          text: "Technologies.Face.FaceVerification"
        },
        {
          img: require("../assets/images/Group7Copy3.png"),
          text: "Technologies.Face.Informationfeedback"
        }
      ],
      pulse: "animated", // 添加圆圈放大动画
      flipInX: "animated",
      list_img: require("../assets/images/portiaita.png"),
      list_bottom_img: require("../assets/images/portiaitb.png")
    };
  },
  components: { headerbar },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.TechnologyPage.style.height = clientHeight - 80 + "px";
      // this.$refs.TechnologyPage1.style.lineHeight = clientHeight - 80 + "px";
      if (document.documentElement.clientWidth >= 1270) {
        this.$refs.TechnologyPage2.style.height = clientHeight - 80 + "px";
        this.$refs.TechnologyPage3.style.height = clientHeight - 80 + "px";
        this.$refs.TechnologyPage4.style.height = clientHeight - 80 + "px";
        this.$refs.TechnologyPage6.style.height = clientHeight - 80 + "px";
        this.$refs.TechnologyPage7.style.height = clientHeight - 80 + "px";
      }

      // this.$refs.homePage3.style.height = clientHeight - 450 + 'px';
    },
    ADASVideoBtn() {
      this.ADASvideo = false;
      var video = document.getElementById("video");
      video.play();
    },
    Facebutton() {
      window.open("https://www.mall-ai.com/#/onlineDemo");
    },
    // 鼠标放上和离开事件
    enterOrLeave(val, index) {
      // console.log()
      if (val === 1) {
        $($(".Technology_ADAS_list_img")[index])
          .addClass("pulse")
          .siblings()
          .removeClass("pulse");
        $($(".Technology_DMS_list_img")[index])
          .addClass("pulse")
          .siblings()
          .removeClass("pulse");
        $(".Technology_Face_text").addClass("pulse");
      } else {
        $(".Technology_ADAS_list_img").removeClass("pulse");
        $(".Technology_DMS_list_img").removeClass("pulse");
        $(".Technology_Face_text").removeClass("pulse");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*隐藏video的下载按钮*/
/*video::-internal-media-controls-download-button {
    display: none;
}*/
video::-webkit-media-controls {
  overflow: hidden !important;
}
video::-webkit-media-controls-enclosure {
  width: calc(100% + 32px);
  margin-left: auto;
}

.Technology_box {
  width: 100%;
  height: 100%;
}

/*第一屏*/

@media screen and (max-width: 1921px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .Technology {
    width: 100%;
    height: 100%;
    background: url("../assets/images/BitmapCopy.png") no-repeat center center;
    /*background-size: 100% 100%;*/
  }
}

@media screen and (min-width: 1921px) {
  .Technology {
    width: 100%;
    height: 100%;
    background: url("../assets/images/BitmapCopy.png") no-repeat center center;
    /*background-size: 100% 100%;*/
    background-color: #000;
  }
}
@media screen and (min-width: 1505px) and (max-width: 1604px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/

  .Technology_ADASVideo_content {
    width: 600px;
    height: 400px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
    position: relative;
  }
  .Technology_ADAS_content {
    display: flex;
    justify-content: space-around;
    width: 1153px;
    margin: 0 auto;
    margin-top: 98px;
    margin-bottom: 30px;
  }
  .Technology_DMS_title {
    padding-top: 180px;
    text-align: center;
  }

  .Technology_DMS_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 90px;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 90px;
  }
  .Technology_Face_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 80px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .Technology_Face_text {
    display: block;
    width: 260px;
    margin: 0px auto;
    margin-top: 125px;
    height: 48px;
    border: 1px solid #c1c1c1;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    text-align: center;
    margin-bottom: 60px;
  }
  .Technology_Face {
    width: 78%;
    margin: 0px auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .Technology_number_top,
  .Technology_number_bottom {
    display: flex;
    width: 828px;
    margin: 0px auto;
  }
  .Technology_number_top li,
  .Technology_number_bottom li {
    height: 150px;
    margin-top: 180px;
  }
  .Technology_number_bottom {
    margin-top: 50px;
    padding-bottom: 70px;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1504px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/

  .Technology_ADASVideo_content {
    width: 600px;
    height: 400px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
    position: relative;
  }
  .Technology_ADAS_content {
    display: flex;
    justify-content: space-around;
    width: 1153px;
    margin: 0 auto;
    margin-top: 98px;
    margin-bottom: 30px;
  }
  .Technology_DMS_title {
    padding-top: 60px;
    text-align: center;
  }

  .Technology_DMS_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 90px;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 90px;
  }
  .Technology_Face_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 80px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .Technology_Face_text {
    display: block;
    width: 260px;
    margin: 0px auto;
    margin-top: 125px;
    height: 48px;
    border: 1px solid #c1c1c1;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    text-align: center;
    margin-bottom: 60px;
  }
  .Technology_Face {
    width: 78%;
    margin: 0px auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .Technology_number_top,
  .Technology_number_bottom {
    display: flex;
    width: 828px;
    margin: 0px auto;
  }
  .Technology_number_top li,
  .Technology_number_bottom li {
    height: 150px;
    margin-top: 80px;
  }
  .Technology_number_bottom {
    margin-top: 50px;
    padding-bottom: 70px;
  }
}

@media screen and (min-width: 1251px) and (max-width: 1399px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .Technology_ADASVideo_content {
    width: 600px;
    height: 400px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
    position: relative;
  }
  .Technology_ADAS_content {
    display: flex;
    justify-content: space-around;
    width: 1153px;
    margin: 0 auto;
    margin-top: 98px;
    margin-bottom: 30px;
  }
  .Technology_DMS_title {
    padding-top: 60px;
    text-align: center;
  }

  .Technology_DMS_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 90px;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 90px;
  }
  .Technology_Face_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 80px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .Technology_Face_text {
    display: block;
    width: 260px;
    margin: 0px auto;
    margin-top: 125px;
    height: 48px;
    border: 1px solid #c1c1c1;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    text-align: center;
    margin-bottom: 60px;
  }
  .Technology_Face {
    width: 78%;
    margin: 0px auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .Technology_number_top,
  .Technology_number_bottom {
    display: flex;
    width: 828px;
    margin: 0px auto;
  }
  .Technology_number_top li,
  .Technology_number_bottom li {
    height: 150px;
    margin-top: 80px;
  }
  .Technology_number_bottom {
    margin-top: 50px;
    padding-bottom: 70px;
  }
}
@media screen and (max-width: 1250px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .Technology {
    width: 100%;
    height: 100%;
    background: url("../assets/images/smallBitmapCopy.png") no-repeat center
      center;
    /*background-size: 100% 100%;*/
    background-color: #000;
  }
  .Technology_ADASVideo_content {
    width: 600px;
    height: 400px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
    position: relative;
  }
  .Technology_ADAS_content {
    display: flex;
    justify-content: space-around;
    width: 1153px;
    margin: 0 auto;
    margin-top: 98px;
    margin-bottom: 30px;
  }
  .Technology_DMS_title {
    padding-top: 60px;
    text-align: center;
  }

  .Technology_DMS_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 90px;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 90px;
  }
  .Technology_Face_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 80px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .Technology_Face_text {
    display: block;
    width: 260px;
    margin: 0px auto;
    margin-top: 125px;
    height: 48px;
    border: 1px solid #c1c1c1;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    text-align: center;
    margin-bottom: 60px;
  }
  .Technology_Face {
    width: 78%;
    margin: 0px auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .Technology_number_top,
  .Technology_number_bottom {
    display: flex;
    width: 828px;
    margin: 0px auto;
  }
  .Technology_number_top li,
  .Technology_number_bottom li {
    height: 150px;
    margin-top: 80px;
  }
  .Technology_number_bottom {
    margin-top: 50px;
    padding-bottom: 70px;
  }
}
@media screen and (min-width: 1606px) {
  .Technology_ADASVideo_content {
    width: 600px;
    height: 400px;
    margin: 0 auto;
    margin-top: 70px;
    position: relative;
  }

  .Technology_ADAS_content {
    display: flex;
    justify-content: space-around;
    width: 1153px;
    margin: 0 auto;
    margin-top: 98px;
  }

  .Technology_DMS_title {
    padding-top: 200px;
    text-align: center;
  }

  .Technology_DMS_content {
    display: flex;
    width: 850px;
    margin: 0 auto;
    margin-top: 75px;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .Technology_Face_content {
    display: flex;
    width: 950px;
    margin: 0 auto;
    margin-top: 148px;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .Technology_Face_text {
    display: block;
    width: 260px;
    margin: 0px auto;
    margin-top: 125px;
    height: 48px;
    border: 1px solid #c1c1c1;
    font-size: 14px;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    text-align: center;
  }

  .Technology_Face {
    width: 78%;
    margin: 0px auto;
    text-align: center;
  }

  .Technology_number_top,
  .Technology_number_bottom {
    display: flex;
    width: 828px;
    margin: 0px auto;
    height: 180px;
  }

  .Technology_number_top li,
  .Technology_number_bottom li {
    height: 180px;
    margin-top: 200px;
  }

  .Technology_number_bottom {
    margin-top: 125px;
  }
}

.Technology_content {
  width:840px;
  height: 155px;
  font-size: 52px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 77px;
  letter-spacing: 1px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.content_text {
  color: #fff;
  font-size: 52px;
  letter-spacing: 1px;
  text-align: center;
}

/*第二屏*/

.Technology_wrap {
  width: 100%;
  background: rgba(255, 255, 255, 1);
}

.Technology_ADAS {
  /*width: 78%;*/
  margin: 0px auto;
  text-align: center;
}

.Technology_ADAS_title {
  margin-top: 200px;
  text-align: center;
}

.Technology_ADAS_title p {
  margin: 0px auto;
  width: 85px;
  height: 30px;
  font-size: 30px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.Technology_ADAS_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}

.Technology_ADAS_text {
  margin-top: 75px;
}

.Technology_ADAS_text p {
  margin: 0px auto;
  letter-spacing: 1px;
  width: 615px;
  height: 32px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
}

.Technology_ADAS_list {
  /*margin-left: 78px;*/
}

.Technology_ADAS_list_p {
  height: 30px;
  text-align: center;
  font-size: 18px;
  /* font-family: PingFangSC-Medium; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 15px;
  margin-top: 18px;
}

.Technology_ADAS_list_pp {
  width: 114px;
  height: 30px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 15px;
}

/*第三屏*/

.Technology_wrapa {
  width: 100%;
  background: rgba(251, 251, 251, 1);
}

.Technology_ADASVideo {
  width: 78%;
  margin: 0px auto;
  text-align: center;
}

.Technology_ADASVideo_title {
  width: 220px;
  margin: 0px auto;
  padding-top: 200px;
  letter-spacing: 1px;
  height: 30px;
  font-size: 30px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.Technology_ADASVideo_title p {
  width: 40px;
  height: 3px;
  background: red;
  margin: 0px auto;
  margin-top: 23px;
}

.ADASvideo {
  width: 600px;
  height: 400px;
  margin: 0 auto;
}

.Technology_ADASVideo_content_img {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*第四屏*/

.Technology_wrapb {
  width: 100%;
  background: url("../assets/images/Rectangle3Copy2.png") no-repeat;
  background-size: 100% 100%;
}

.Technology_DMS {
  width: 78%;
  margin: 0px auto;
  text-align: center;
}

.Technology_DMS_title p {
  margin: 0px auto;
  width: 85px;
  height: 30px;
  font-size: 30px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  letter-spacing: 1px;
}

.Technology_DMS_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}

.Technology_DMS_text {
  margin-top: 75px;
}

.Technology_DMS_text p {
  margin: 0px auto;
  letter-spacing: 1px;
  width: 700px;
  height: 26px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: #fff;
  line-height: 26px;
}

.Technology_DMS_list {
  width: 193px;
  height: 158px;
  margin-left: 17px;
  justify-content: center;
}

.Technology_DMS_list_img {
  width: 192px;
  height: 107px;
}

.Technology_DMS_list_img img {
  width: 100%;
  height: 100%;
}

.Technology_DMS_list p {
  width: 192px;
  height: 49px;
  line-height: 49px;
  text-align: center;
  background: rgba(44, 44, 44, 1);
  color: #fff;
}

/*第五屏*/

.Technology_Face_title {
  padding-top: 200px;
  text-align: center;
}

.Technology_Face_title p {
  margin: 0px auto;
  width: 436px;
  height: 30px;
  font-size: 30px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  letter-spacing: 1px;
}

.Technology_Face_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}

.Technology_Face_list {
  margin-left: 120px;
  justify-content: center;
}

.Technology_Face_list p {
  width: 80px;
  height: 25px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

/*第六屏*/

.Technology_wrapd {
  width: 100%;
  background: url("../assets/images/Rectangle3Copy2.png") no-repeat;
  background-size: 100% 100%;
}

.Technology_number {
  width: 78%;
  margin: 0px auto;
  text-align: center;
}

.list_top p,
.listt_bottom_top p {
  /* width: 90px; */
  height: 30px;
  font-size: 20px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  margin-top: 17px;
  text-align: left;
}

.list_top span,
.listt_bottom_top span {
  display: block;
  width: 40px;
  height: 3px;
  background: rgba(255, 33, 60, 1);
  margin-top: 20px;
}

.list_bottom p,
.list_t_bottom_bottom p {
  width: 420px;
  height: 60px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  text-align: left;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  margin-top: 25px;
}

.list_img {
  width: 320px;
  height: 180px;
  background: #fff;
  margin-left: 80px;
}

.list_bottom_img {
  width: 320px;
  height: 180px;
  background: #fff;
}

.listt_bottom_right {
  margin-left: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Technology.vue